// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1035":"97fa61a1cddfa2d0","4431":"812b364bbec8697b","7892":"08aa00cfc942326f"}[chunkId] + ".css";
};